import { render, staticRenderFns } from "./dsgvo-content.vue?vue&type=template&id=9167bd86&scoped=true&"
import script from "./dsgvo-content.vue?vue&type=script&lang=js&"
export * from "./dsgvo-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167bd86",
  null
  
)

component.options.__file = "dsgvo-content.vue"
export default component.exports